<form [formGroup]="noteFormGroup">
    <div mat-dialog-title style="display:flex; flex-direction: row; flex-wrap: wrap;">
        <h3>Shift Notes ({{shiftDate}} {{shift}})</h3>
        <div style="margin-left: auto; padding-top: 24px;">
            <button mat-button color="primary" (click)="openSummary()"><mat-icon style="font-size: 24px; width: 24px; height: 24px; line-height: 24px;">smart_toy_outline</mat-icon> View AI Summary</button>
        </div>
    </div>
    <mat-dialog-content>
        <div>
            <div>
                <mat-label>Add New Note:</mat-label>
            </div>
            <mat-form-field [style.width.px]="450" appearance="outline">
                <textarea matInput rows="5" cols="40" placeholder="Add New Note" formControlName="Note"></textarea>
            </mat-form-field>
        </div>

        <div>
            <mat-form-field appearance="fill">
                <mat-label>Zone</mat-label>
                <mat-select placeholder="Zone" formControlName="Zone" (selectionChange)="updateFilterShiftNotes()">
                    <mat-option *ngFor="let d of zoneData" [value]="d.zone_id">{{d.zone_id}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div>
            <button mat-raised-button color="primary" (click)="saveNote()" [disabled]="noteFormGroup.invalid">Save</button>
        </div>
        <div>
            <h4>Existing Notes:</h4>
            <div style="overflow-y:scroll; max-height:200px;">
                <div *ngIf="loadingData">
                    Loading...
                </div>
                <mat-table [dataSource]="filteredShiftNotes">

                    <ng-container matColumnDef="Note">
                        <mat-cell *matCellDef="let d">{{d.Note}}</mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="Action">
                        <mat-cell *matCellDef="let d"><button mat-button color="primary" (click)="editNote(d)"><mat-icon>create</mat-icon></button></mat-cell>
                    </ng-container>

                    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                </mat-table>
            </div>
        </div>
    </mat-dialog-content>

    
    <mat-dialog-actions>
        <span class="spacer"></span>
        <button mat-raised-button color="primary" (click)="onNoClick()">Close</button>
    </mat-dialog-actions>
</form>